<template>
    <div :key='key' class='image-outer-container'>
         <div class='no-image-set-container' v-if='!element.element_config.config.image_src && page_builder_mode'>
            <i class="fa-light fa-image icon"></i>
            <div class='no-image-selected-text'>No image selected</div>
        </div>
        <div v-else>
            <div v-if="(element.element_config.config.different_image_on_mobile && !mobile_mode) || !element.element_config.config.different_image_on_mobile">
                <DynamicImageContainer @click='imageClick' class='image-container' :class='[classes.image, {"element-has-link" : element.element_config.config.url != ""}]' :style='[element.element_config.compiled_styles, custom_styles.image]' :image='element.element_config.config.image_src' v-if="element.element_type == 'image'" />
            </div>
             <div v-else>
                <DynamicImageContainer @click='imageClick' class='image-container' :class='[classes.image, {"element-has-link" : element.element_config.config.url != ""}]' :style='[element.element_config.compiled_styles, custom_styles.image]' :image='element.element_config.config.mobile_img_src' v-if="element.element_type == 'image'"/>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {DynamicImageContainer},
    props:['element', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            key: 0,
            mobile_mode: false,
            screen_size_check_timeout: null,
            custom_styles: {},
            classes: []
        }
    },
    methods:{
        imageClick(){
            if(!this.page_builder_mode){
                if(this.element.element_config.config.url != ''){
                    if(this.element.element_config.config.url_type != 'external'){
                        this.$router.push(this.element.element_config.config.url);
                    }
                    else{
                        window.location.href = this.element.element_config.config.url;
                    }
                }
            }
        },
        setClasses(){
            if(this.element.element_config.compiled_classes != null){
                this.classes = this.element.element_config.compiled_classes;
            }
        },
        CheckMobileMode(){
            let canvas = document.getElementsByClassName('canvas-container')[0];
            if(typeof canvas !== 'undefined'){
                new ResizeObserver(()=>{
                    clearTimeout(this.screen_size_check_timeout);

                    this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                        if(canvas.clientWidth <= 768){
                            this.mobile_mode = true;
                        }
                        else{
                            this.mobile_mode = false;
                        }
                    
                    }, 1);
                }).observe(canvas);
            }
        },
    },
    watch:{
       'element': {
            handler(){
                this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
                this.setClasses();
            },
            deep: true
        }
    },
    mounted(){
        this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
        this.setClasses();
        this.CheckMobileMode();
    }
}
</script>

<style lang="scss" scoped>
.image-outer-container{
    width: 100%;
    flex-grow: 1;
    line-height: 0;
}

.image-container{
    width: 100%;
    object-fit: cover;
}

.element-has-link{
    cursor: pointer;
}

.no-image-set-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: inherit;
    height: inherit;
    text-align: center;
    align-content: center;
    color: #868e96;
    align-content: center;
    height: 200px;
}

.no-image-selected-text{
    font-size: 1rem;
    text-align: center;
    line-height: 1;
}

.icon{
    font-size: 1.2rem;
}
</style>